import { Component, Input } from '@angular/core';
import { Track } from '@app/core/models/Track';
import { PlayAudio, Resume, Stop } from '@app/core/states/audio.actions';
import { PlaylistTracksState } from '@app/library/states/playlist-tracks.state';
import { AddToPlaylistRequest } from '@app/library/states/playlists.actions';
import { Dispatch } from '@ngxs-labs/dispatch-decorator';
import { Store } from '@ngxs/store';

@Component({
  selector: 'rk-playlist-add-track-line',
  templateUrl: './playlist-add-track-line.component.html',
  styleUrls: ['./playlist-add-track-line.component.scss'],
})
export class PlaylistAddTrackLineComponent {
  @Input()
  track: Track;

  @Input()
  first = false;

  @Input()
  isPlaying = false;

  @Input()
  isLoaded = false;

  constructor(private readonly store: Store) {}

  addTrackToPlaylist(idTrack: number) {
    const currentPlaylist = this.store.selectSnapshot(
      PlaylistTracksState.currentPlaylist,
    );
    this.store.dispatch(new AddToPlaylistRequest(currentPlaylist, [idTrack]));
  }

  @Dispatch()
  playTrack(track: Track) {
    if (this.isPlaying && this.isLoaded) {
      return new Stop();
    }
    if (this.isLoaded) {
      return new Resume();
    }

    return new PlayAudio(track);
  }

  dndDragImageOffsetFunction(): { x: number; y: number } {
    return { x: 0, y: 0 };
  }
}
